/*
this table container is use for client side filter, sorting and pagination 
In this table we can not call api on filter, sorting and pagination
also we can set dynamic last column filter
*/
import React, { Fragment } from 'react';
import {
  useTable,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from 'react-table';
import Pagination from "@mui/material/Pagination";
import { Button, Checkbox, Input, MenuItem, Popover } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import { Filter, DefaultColumnFilter } from './filters';
import classnames from "classnames";
import "./Table.scss";
import HourglassEmptySharpIcon from "@mui/icons-material/HourglassEmptySharp";

import CarbonSettings from "./../../Assets/images/icons/carbon_settings-adjust.svg";
import "./Table.scss";
import { Scrollbars } from 'react-custom-scrollbars-2';
import FormControlLabel from "@mui/material/FormControlLabel";
import { FiberManualRecord, RadioButtonUnchecked } from "@mui/icons-material";
// import { CustomScroll } from "react-custom-scroll";
const DefaultColumnFilter = ({
    column: {
      filterValue,
      setFilter,
      Header,
      preFilteredRows: { length },
    },
    visibleColumns,
}) => {
    const filterColumn = visibleColumns.find((x) => x.Header === Header);

    return (
        <Input
        value={filterValue || ""}
        startAdornment={<SearchIcon />}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={
            filterColumn && filterColumn.placeholder
              ? filterColumn.placeholder
              : ` ${Header}`
          }
      />
    );
  };
   const Filter = ({ column }) => {
    return (
      <div style={{ marginTop: 5 }}>
        {column.canFilter && column.render('Filter')}
      </div>
    );
  };

  //for column visibility settings 
  //indeterminate checkbox
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      rest.title = "";
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <FormControlLabel
          control={<Checkbox {...rest} />}
          // label="Toggle All"
          ref={resolvedRef}
          className={`customCheckBoxCss`}
        />
      );
    }
  );

const TableContainer = ({ columns, data, noDataText,loading,disableLastColumnFilter=false, defaultFilters=[], selectedColumn, displayColumnVisibility=false, isShowSettings=false }) => {
      const defaultColumn = React.useMemo(
          () => ({
            Filter: DefaultColumnFilter,
          }),
          []
        );

  //for column visibility settings 
  const [anchorEl, setAnchorEl] = React.useState(null);
  //popover open
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //for column visibility settings 
  //popover close
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    visibleColumns,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setFilter,
    allColumns,
    getToggleHideAllColumnsProps,
    state: { pageIndex, pageSize },
} = useTable(
    {
        columns,
        data,
        defaultColumn,
        initialState: { 
          pageIndex: 0, 
          pageSize: 10 ,
          hiddenColumns: isShowSettings ? columns
            .filter((el) => !el.isVisible)
            .map((el) => el.accessor) : [],
        },
    },
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
    );

    // Apply default filters when component mounts or when defaultFilters change
    React.useEffect(() => {
      if (defaultFilters && defaultFilters.length > 0) {
        defaultFilters.forEach(filter => {
          if (filter.id && filter.value !== undefined) {
            setFilter(filter.id, filter.value);
          }
        });
      }
    }, [setFilter, defaultFilters]);

  //if visible column change the send data to relevent page for state save if want
  // Handle the visibility of columns
  // If the selected column is changed and the settings are shown, then send the data to the relevant page for state save if wanted
  React.useEffect(() => {
    if (selectedColumn && isShowSettings) {
      let columnDataState = {};
      allColumns.forEach((data) => {
        columnDataState[data.id] = data.isVisible;
      });
      selectedColumn(columnDataState);
    }
  }, [visibleColumns]);
    
  return (
    <React.Fragment>
      <div
        className={`ReactTable -striped -highlight  pb-4 pb-xl-5`}
      >
      <div className="column-visibility-wrap d-flex justify-content-end mt-3">
        {displayColumnVisibility && isShowSettings && (
          <React.Fragment>
            <Button
              aria-controls="simple-menu"
              onClick={handleClick}
              style={{ textTransform: "none", fontWeight: "bold", color: "inherit" }}
              aria-describedby="simple-popover"
            >
              <img
                src={CarbonSettings}
                alt="CarbonSettings"
                className="mr-2"
              />
              Settings
            </Button>
            <Popover
              id="simple-popover"
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              className="column-visibility-popover"
              PaperProps={{
                style: {
                  zIndex: 9999
                }
              }}
            >
              <Scrollbars 
                style={{
                  height: "420px", 
                  minWidth: "200px"
                }} 
                autoHide 
                renderThumbVertical={({ style, ...props }) => (
                  <div 
                    {...props} 
                    style={{ 
                      ...style,
                      top: 0, 
                      overflow: "hidden",
                      backgroundColor: "#CB998D",
                      opacity: 0.5,
                      borderRadius: '10px',
                      width: '6px'
                    }}
                  />
                )}
                renderThumbHorizontal={({ style, ...props }) => (
                  <div 
                    {...props} 
                    style={{ 
                      ...style,
                      left: 0, 
                      overflow: "hidden",
                      backgroundColor: "#CB998D",
                      opacity: 0.5,
                      borderRadius: '10px',
                      height: '8px'
                    }}
                  />
                )}
              >
                <div className="column-visibility-menu">
                  <MenuItem>
                    <IndeterminateCheckbox
                      {...getToggleHideAllColumnsProps()}
                      color="default"
                      style={{
                        opacity: 0.5
                      }}
                    />
                  </MenuItem>
                  {allColumns.map((column, index) => (
                    <MenuItem key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<RadioButtonUnchecked fontSize="small" />}
                            checkedIcon={
                              <FiberManualRecord fontSize="small" />
                            }
                            {...column.getToggleHiddenProps()}
                            name="selectedColumns"
                            color="default"
                            style={{
                              opacity: 0.5
                            }}
                          />
                        }
                        label={column.Header}
                      />
                    </MenuItem>
                  ))}
                </div>
              </Scrollbars>
            </Popover>
          </React.Fragment>
        )}
      </div>
        <div className="tableWrap">
          <table {...getTableProps()} className="rt-table table">
            <thead className="rt-thead -header">
            {headerGroups.map((headerGroup, headerGroupIndex) => (
                <tr
                  key={headerGroupIndex}
                  {...headerGroup.getHeaderGroupProps()}
                  className="rt-tr"
                >
                  {headerGroup.headers.map((column, key) => (
                    <th
                      key={key}
                      className={classnames("rt-th rt-resizable-header", {
                        "-cursor-pointer":
                          column.render("canSort"),
                        "-sort-asc": column.isSorted && !column.isSortedDesc,
                        "-sort-desc": column.isSorted && column.isSortedDesc,
                      })}
                      style={{
                        minWidth: column.colWidth ? column.colWidth : 100,
                        pointerEvents:"auto"
                      }}
                    >
                      <div
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="rt-resizable-header-content"
                      >
                        <span>{column.render("Header")}</span>
                      </div>

                      {disableLastColumnFilter && headerGroup.headers.length - 1 ===
                      key ? null : column.canFilter ? (
                        <div className={`rt-filter-wapper`}>
                          {column.render("Filter")}
                        </div>
                      ) : column.disableFilters ? null : <div className={`rt-filter-wapper`}>
                          {column.render("Filter")}
                          </div>}
                        
                      {/* ) : null} */}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className="rt-tbody">
              { loading ? (
                <tr>
                  <td colSpan={visibleColumns.length} className="text-center">
                    <div className="wrapper">
                      <HourglassEmptySharpIcon />
                      <p className="pl-2">Loading...</p>
                    </div>
                  </td>
                </tr>
              ) : page.length === 0 ? (
                <tr>
                  <td className="text-center" colSpan={visibleColumns.length}>
                    <span className="no-data-message">{noDataText}</span>
                  </td>
                </tr>
              ) : (
                page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      key={i}
                      {...row.getRowProps()}
                      className={classnames(
                        "rt-tr",
                        { " -odd": i % 2 === 0 },
                        { " -even": i % 2 === 1 }
                      )}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()} className="rt-td">
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-bottom mt-3 d-flex justify-content-end">
          <Pagination
            className="custom-pagination"
            count={pageCount}
            page={pageIndex + 1}
            onChange={(e, value) => {
              gotoPage(value - 1);
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TableContainer;
